import type { ChatParticipantRole } from '@klaro7/shared-types';

export const roleLabel: Record<ChatParticipantRole, string> = {
  user: 'Cliente',
  professional: 'Consulente',
};

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
